import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, Grid, ConfigProvider } from "antd";
import HeaderDefault from "../HeaderDefault/HeaderDefault";
import FooterDefault from "../FooterDefault/FooterDefault";
import * as AntdIcons from "@ant-design/icons";
import whitelabelConfig from "@whitelabel-config";
import { useTranslation } from "react-i18next";
import type { MenuProps } from "antd";
import BrandColors from "@brand-colors";
import { useDispatch } from "react-redux";
import { portalActions } from "store/portal-slice";
import "./MpWithSidebarLayout.css";
import { useSelector } from "react-redux";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import i18n from "i18next";
const { Sider } = Layout;
const { useBreakpoint } = Grid;
const MpWithSidebarLayout = () => {
  const location = useLocation();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const { t, i18n } = useTranslation();
   const languageFromDropdown = useSelector(
     (state:any) => state.portal.uiState.LanguageChangedFromDropdown
   );
  const [menuItems, setMenuItems] = useState([]);
  const CustomIcon = (type: string) => {
    const AntdIcon = AntdIcons[type];
    return <AntdIcon />;
  };
  const [collapsed, setCollapsed] = useState(true);
  const uiState = useSelector((state: any) => state.portal.uiState);
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log(preferredLanguage,"preferredLanguage")
  const [isRightAlign, setIsRightAlign] = useState(false);
  
  useEffect(() => {
    prepareMenuItems();
  }, []);
  useEffect(() => {
    if (languageFromDropdown) {
      prepareMenuItems();
      dispatch(portalActions.resetLanguageChangeFlag()); // reset after handling
    }
  }, [languageFromDropdown]);
  useEffect(() => {    
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(preferredLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [ whitelabelConfig, preferredLanguage]);
  
  useEffect(() => {
    const clean = () => document.querySelectorAll("[aria-describedby]").forEach((el) => {
      const id = el.getAttribute("aria-describedby");
      if (id && !document.getElementById(id)) el.removeAttribute("aria-describedby");
    });
    new MutationObserver(clean).observe(document.body, { attributes: true, attributeFilter: ["aria-describedby"], childList: true, subtree: true });
    clean();
  }, []);
  
  const prepareMenuItems = () => {
    let menus: any = [];
    whitelabelConfig?.modules.forEach((m: any, mIndex: any) => {
      menus.push({
        label: t(`MENUS.${m.MENU_LABEL}`),
        key: `/${m.MODULE}`, // Set the key to the module route path
        icon: CustomIcon(m.ICON ? m.ICON : "InfoCircleOutlined"),
        module: m.module,
      });
    });
    setMenuItems(menus);
  };

  const onMenuClick: MenuProps["onClick"] = (e) => {
    {
      screens.lg ? setCollapsed(false) : setCollapsed(true);
    }
    navigate(e.key);
  };

  return (
    <Layout>
      <HeaderDefault />
      <Layout style={{ zIndex: "999" }}>
        <Sider
          width={315}
          style={{
            background: "#ffffff",
            position: "fixed",
            zIndex: "99",
            height: "100%",
            transition: "none",            
          }}
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={(broken) => {
            console.log(broken, "Broken");
          }}
          collapsed={collapsed}
          onCollapse={setCollapsed}
        >
          <div className="demo-logo-vertical" />
          <ConfigProvider
            theme={{
              components: {
                Menu: {
                  itemSelectedBg: BrandColors.BUTTON_BG,
                  itemSelectedColor: "#fff",
                },
              },
            }}
          >
            <Menu
              onClick={onMenuClick}
              selectedKeys={[location.pathname]}
              style={{ height: "100%", borderRight: 0, fontSize: "16px" }}
              mode="inline"
              defaultSelectedKeys={["0"]}
            >
              {menuItems.map((item) => (
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  style={{
                    fontWeight: "600",
                    height: "44px",
                    lineHeight: "44px",
                    transition: "none",
                    paddingLeft: "20px",
                    textAlign: isRightAlign ? "right" : "left",
                    flexDirection: isRightAlign ? "row-reverse" : "row",
                    gap: isRightAlign ? "10px" : "0",
                  }}
                >
                  {item.label}
                </Menu.Item>
              ))}
            </Menu>
          </ConfigProvider>
        </Sider>
        <div
          style={{
            width: screens.lg ? "100%" : "100%",
            padding: screens.lg ? "20px 30px 20px" : "10px 10px 10px",
            paddingLeft: screens.lg ? "345px" : "10px",
            height: "calc(100vh - 110px)",
            overflow: "auto",
          }}
        >
          <div data-testid="outlet">
            <Outlet />
          </div>
        </div>
      </Layout>
      <div data-testid="footer-default">
        <FooterDefault />
      </div>
    </Layout>
  );
};

export default MpWithSidebarLayout;
